import React, {Component} from 'react';
import _ from 'lodash';
import {isMobile} from 'react-device-detect';

export class StatusFilter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      current_status: "ทั้งหมด"
    }
    
    this.renderStatus = this.renderStatus.bind(this);
    this.onSelectStatus = this.onSelectStatus.bind(this);
  }

  onSelectStatus(event){
    const value = event.target.value;

    this.setState({
      current_status: value
    }, function(){
      this.props.handleChangeStatus(value);
    });
  }

  handleChangeStatus(status){
    this.props.handleChangeStatus(status);
  }

  renderStatus(status, index){
    return (
      <label 
        key={index} 
        onClick={this.handleChangeStatus.bind(this, status)} 
        className={`btn btn-sm btn-secondary ${this.props.active_status === status && 'active'}`}>
        <input type="radio" name="status_filter" id={`status_filter_${index}`} defaultChecked="true" /> 
        {status}
      </label>
    )
  }

  render(){
    
    return (
      <div className='row mb-1'>
        <div className='col-md-1'><b>สถานะ</b></div>
        <div className='col-md-11'>

          {isMobile ? (
            <select 
              className='form-control form-control-sm'
              name='status_filter'
              value={this.state.current_status}
              onChange={this.onSelectStatus}>
              <option value=''>ทั้งหมด</option>
              {_.map(this.props.available_statuses, function(status, index){
                return <option key={index} value={status}>{status}</option>
              })}
            </select>
          ) : (
            <div className="btn-group btn-group-toggle" data-toggle="buttons">
              <label
                onClick={this.handleChangeStatus.bind(this, '')} 
                className={`btn btn-sm btn-secondary ${this.props.active_status === '' && 'active'}`}>
                <input type="radio" name="status_filter" id={'status_filter'} defaultChecked="true" /> 
                ทั้งหมด
              </label>

              {_.map(this.props.available_statuses, this.renderStatus)}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default StatusFilter;



// WEBPACK FOOTER //
// ./src/components/documents/filters/StatusFilter.js